import { getExecutorWiresApi } from '@/api/v1/executor/getExecutorWiresApi';
import { prepareSearchNameListApiParams } from '@/helpers/apiHelpers/requestHelpers';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';

export const loadExecutorWires = async (queryParams) => {
  const apiParams = prepareSearchNameListApiParams(queryParams);

  try {
    const response = await getExecutorWiresApi(apiParams);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
